import "core-js/modules/es.array.filter";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      optionsoRganization: [],
      formData: {
        id: "",
        email: "",
        password: "",
        nickname: "",
        auth_group_id: "",
        status: 1,
        can_repair: 2,
        is_develop: 2,
        sub_dev: "",
        enterprise_id: ''
      },
      userList: [],
      enterpriseList: [],
      userId: '',
      rules: {
        email: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }],
        nickname: [{
          required: true,
          message: "请输入昵称",
          trigger: "blur"
        }],
        auth_group_id: [{
          required: true,
          message: "请选择角色",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "请选择用户状态",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var roleList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.userAddList({
                  id: 't'
                });

              case 2:
                roleList = _context.sent;
                _this.optionsoRganization = roleList.data;

                _this.copyPrimitive();

                _this.getUserList(id);

                _this.getEnterpriseList();

                _this.userId = '';

                if (!id) {
                  _context.next = 12;
                  break;
                }

                _this.userId = id;
                _context.next = 12;
                return _this.$api.userDetails({
                  id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this.formData = _objectSpread({}, res.data.admin_info);
                    _this.formData.sub_dev = _this.formData.sub_dev != 0 ? _this.formData.sub_dev : '';

                    if (_this.formData.enterprise_id) {
                      _this.getUserList(id, _this.formData.enterprise_id);
                    }
                  }
                });

              case 12:
                _this.copyData();

                _this.dialogFormVisible = true;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    subChange: function subChange(e) {
      this.userList = [];
      this.formData.sub_dev = "";

      if (e) {
        this.getUserList(this.userId, e);
      } else {
        this.getUserList(this.userId);
      }
    },
    getUserList: function getUserList(id) {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var enterpriseId;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                enterpriseId = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : "";

                _this2.$api.subUserList({
                  page: 1,
                  page_size: -1,
                  enterprise_id: enterpriseId,
                  id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this2.userList = res.data.filter(function (item) {
                      return item.id != id;
                    });
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getEnterpriseList: function getEnterpriseList() {
      var _this3 = this;

      this.$api.enterpriseList({
        page: 1,
        page_size: -1
      }).then(function (res) {
        if (res.status == 200) {
          _this3.enterpriseList = res.data;
        }
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.$refs.ruleForm.validate(function (valid) {
                  if (valid) {
                    var reqFn = _this4.formData.id == '' ? 'userAdd' : 'userUpd';
                    _this4.formData.sub_dev = _this4.formData.sub_dev ? _this4.formData.sub_dev : 0;

                    if (_this4.formData.is_develop == 2) {
                      delete _this4.formData.enterprise_id;
                    }

                    _this4.$api[reqFn](_this4.formData).then(function (res) {
                      if (res.status == 200) {
                        _this4.$message.success(_this4.formData.id == '' ? '添加成功' : '修改成功');

                        _this4.$emit('change');

                        _this4.dialogFormVisible = false;
                      }
                    });
                  }
                });

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};